<div medptevlog style="height:100%;">
  <!--  Terminal  -->
  <!--<div class="terminal" [ngSwitch]="selection.value">
      <pre *ngSwitchDefault>ng generate component xyz</pre>
      <pre *ngSwitchCase="'material'">ng add @angular/material</pre>
      <pre *ngSwitchCase="'pwa'">ng add @angular/pwa</pre>
      <pre *ngSwitchCase="'dependency'">ng add _____</pre>
      <pre *ngSwitchCase="'test'">ng test</pre>
      <pre *ngSwitchCase="'build'">ng build</pre>
  </div>-->
  <div *ngIf="showLoader | async">
    <div class="ldr-overlay">
      <div style=" height: 100%; display: flex; justify-content: center; align-items: center; overflow: hidden; animation-delay: 1s; flex-direction: column; ">
        <div class="loading"> <span></span> <span></span> <span></span> <span></span> <span></span> <span></span> <span></span></div>
        <div class="ldr-message" [innerHTML]="loaderText"></div>
      </div>
    </div>
  </div>
  <medpt-top-notification></medpt-top-notification>
  <medpt-root-css-variables></medpt-root-css-variables>
  <router-outlet *ngIf="isConnected"></router-outlet>
  <medpt-feedback-bot *ngIf="userLoggedIn"></medpt-feedback-bot>
 
  <div *ngIf="!isConnected">
    <div class="view-container">
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <h2 style="position: absolute; left: 50%; top: 35%; -webkit-transform: translate(-50%, -50%); transform: translate(-50%, -50%); text-align: center; font-family: Fabrikat-Medium;">
            You seem to be offline.
            <br />
            <small>Please check your Internet connection.</small>
            <br />
            <br />
            <button type="button" class="btn btn-primary" onclick="window.location.reload(true)" style="float: none;">Reload <i class='fa fa-refresh fa-spin fa-fw'></i></button>
          </h2>
        </div>
      </div>
    </div>
    <!--<app-footer></app-footer>-->
  </div>
</div>
